import React from 'react'
let vector = ['1'];
let total = 0,price = 0, total_d = 0;
let validate_brand_select = 1;
let validate_category_select = 1;
let countLine = 1,countBrand=1,countCategory = 1;

const List = function list ({text,brands,categories,years,vehicles,products,changeBrand,changeCategory,option,onChangeOption,prev,next,changeYear,changeVehicle,changePrice,brand_select,category_select,linesT,brandOpen,categoriesOpen,yearsOpen,vehiclesOpen,priceOpen,lineOpen,lines,changeLine,brandsT,categoriesT,clearFilter,clearMobile}){
    let cont = 0,page=1,pageNext = 0;
    return (
        <main>
            <div className="back flex w90">
                <a href={https} className="flex">
                    <img src={https+"img/back.svg"} alt="⬅"/>
                    <span>Atrás</span>
                </a>
            </div>
        
            <div className="bannerShop w90 dnone">
                <a href={https+'product/'+text.product_id}>
                    <img src={https+text.img} alt="bannerShop"/>
                </a>
            </div>
        
            <section className="shop">
            <div className="container w90">
                <div className="results flex" id="results">
                    <div className="itemResult categories" style={{display:'none'}}>
                        <p>
                            <span className='name'></span>
                            <span onClick={()=> clearMobile('categories')}>
                                X
                            </span>
                        </p>
                    </div>
                    <div className="itemResult brands" style={{display:'none'}}>
                        <p>
                            <span className='name'></span>
                            <span onClick={()=> clearMobile('brands')}>
                                X
                            </span>
                        </p>
                    </div>
                    <div className="itemResult lines" style={{display:'none'}}>
                        <p>
                            <span className='name'></span>
                            <span onClick={()=> clearMobile('lines')}>
                                X
                            </span>
                        </p>
                    </div>
                    <div className="itemResult years" style={{display:'none'}}>
                        <p>
                            <span className='name'></span>
                            <span onClick={()=> clearMobile('years')}>
                                X
                            </span>
                        </p>
                    </div>
                    <div className="itemResult vehicles" style={{display:'none'}}>
                        <p>
                            <span className='name'></span>
                            <span onClick={()=> clearMobile('vehicles')}>
                                X
                            </span>
                        </p>
                    </div>
                    <div className="itemResult prices" style={{display:'none'}}>
                        <p>
                            <span className='name'></span>
                            <span onClick={()=> clearMobile('prices')}>
                                X
                            </span>
                        </p>
                    </div>
                </div>
                <div 
                    className="searchMob relative flex" 
                    style={{display:'none'}}
                >
                    <img src="/img/search.svg" alt="🔍" className="absolute"/>
                    <input type="search" placeholder="Busca tu producto"/>
                </div>
                <div className="filters flex">
                <div className="openCategories flex" id="openCategories">
                    <p>Filtros</p>
                    <img src="/img/filter.svg" alt="icon-filter"/>
                </div>

                
                <div className="allCategories colflex" id="allCategories">
                    <div className="actions flex">
                    <p>Escoge tus filtros</p>
                    <div className="flex">
                        <a onClick={clearFilter}>Limpiar</a>
                        <a id="closeCategories">Cerrar</a>
                    </div>
                    </div>

                    <div className="flex itemCategory" id="openProduct">
                        <p>Categorías</p>
                        <img src={https+"img/arrow2.svg"} alt="➡"/>
                    </div>

                    <div className="flex itemCategory" id="openMarcas">
                        <p>Marcas</p>
                        <img src={https+"img/arrow2.svg"} alt="➡"/>
                    </div>

                    <div className="flex itemCategory" id="openLines">
                        <p>Lineas</p>
                        <img src={https+"img/arrow2.svg"} alt="➡"/>
                    </div>

                    <div className="flex itemCategory" id="openYear">
                        <p>Año</p>
                        <img src={https+"img/arrow2.svg"} alt="➡"/>
                    </div>

                    <div className="flex itemCategory" id="openVehicle">
                        <p>Vehiculos</p>
                        <img src={https+"img/arrow2.svg"} alt="➡"/>
                    </div>

                    <div className="flex itemCategory" id="openPrice">
                        <p>Precios</p>
                        <img src={https+"img/arrow2.svg"} alt="➡"/>
                    </div>

                    <div 
                        className="selected flex w90"
                        style={{display: "none"}}
                    >
                        <div className="itemResult">
                            <p>Focal</p>
                            <span>X</span>
                        </div>
                        <div className="itemResult">
                            <p>Radios</p>
                            <span>X</span>
                        </div>
                        <div className="itemResult">
                            <p>Mas de $500.000</p>
                            <span>X</span>
                        </div>
                    </div>
                    <a className="applyFilter" style={{display: "none"}}>
                    Aplicar filtro
                    </a>
                </div>

                <div className="subCategory colflex" id="subMarca">
                    <div className="actions flex">
                        <div className="flex subBack" id="subBack">
                        <img src="/img/back.svg" alt="⬅"/>
                        <p>Atrás</p>
                        </div>
                        <div className="flex">
                        <a 
                            href={https+"shop"} 
                            style={{display:'none'}}
                        >
                            Aplicar
                        </a>
                        <a id="closeMarcas">Cerrar</a>
                        </div>
                    </div>
                    {brands.map((b)=>
                        {
                            return (
                                <a 
                                    className="itemSubcategory flex"
                                    onClick={() =>changeBrand(b.id)}
                                >
                                    <p>{b.name}</p>
                                    <img 
                                        id={"brand_mobile_" + b.id}
                                        name={b.name}
                                        className="brand_list_mobile dnone"
                                        src="/img/check.svg" 
                                        alt="selected"
                                    />
                                </a>
                            )
                        }
                    )}
                </div>

                <div className="subCategory colflex" id="subLine">
                    <div className="actions flex">
                        <div className="flex subBack" id="subLines">
                            <img src="/img/back.svg" alt="⬅"/>
                            <p>Atrás</p>
                        </div>
                        <div className="flex">
                        <a 
                            href={https+"shop"} 
                            style={{display:'none'}}
                        >
                            Aplicar
                        </a>
                        <a id="closeLines">Cerrar</a>
                        </div>
                    </div>
                    {lines.map((l)=>
                        {
                            return (
                                <a 
                                    className="itemSubcategory flex"
                                    onClick={() =>changeLine(l.id)}
                                >
                                    <p>{l.name}</p>
                                    <img 
                                        id={"line_mobile_" + l.id}
                                        name={l.name}
                                        className="line_list_mobile dnone"
                                        src="/img/check.svg" 
                                        alt="selected"
                                    />
                                </a>
                            )
                        }
                    )}
                </div>

                    <div className="subCategory colflex" id="subProduct">
                    <div className="actions flex">
                        <div className="flex subBack" id="backProduct">
                        <img src="/img/back.svg" alt="⬅"/>
                        <p>Atrás</p>
                        </div>
                        <div className="flex">
                        <a 
                            href={https+"shop"} 
                            style={{display:'none'}}
                        >
                            Aplicar
                        </a>
                        <a id="closeProduct">Cerrar</a>
                        </div>
                    </div>
                    {categories.map((c)=>
                        {
                            return (
                                <a 
                                    className="itemSubcategory flex"
                                    onClick={() =>changeCategory(c.id)}
                                >
                                    <p>{c.name}</p>
                                    <img 
                                        name={c.name}
                                        id={"category_mobile_" + c.id}
                                        className="category_list_mobile dnone"
                                        src={https+"img/check.svg"} 
                                        alt="selected"
                                    />
                                </a>
                            )
                        }
                    )}

                    </div>

                    <div className="subCategory colflex" id="subYear">
                    <div className="actions flex">
                        <div className="flex subBack" id="backYear">
                        <img src="/img/back.svg" alt="⬅"/>
                        <p>Atrás</p>
                        </div>
                        <div className="flex">
                        <a 
                            href={https+"shop"} 
                            style={{display:'none'}}
                        >
                            Aplicar
                        </a>
                        <a id="closeYear">Cerrar</a>
                        </div>
                    </div>
                    {years.map((y)=>
                        {
                            return (
                                <a 
                                    className="itemSubcategory flex"
                                    onClick={() =>changeYear(y.id)}
                                >
                                    <p>{y.name}</p>
                                    <img 
                                        name={y.name}
                                        id={"year_mobile_" + y.id}
                                        className="year_list_mobile dnone"
                                        src={https+"img/check.svg"} 
                                        alt="selected"
                                    />
                                </a>
                            )
                        }
                    )}

                    </div>
                    
                    <div className="subCategory colflex" id="subVehicle">
                    <div className="actions flex">
                        <div className="flex subBack" id="backVehicle">
                        <img src="/img/back.svg" alt="⬅"/>
                        <p>Atrás</p>
                        </div>
                        <div className="flex">
                        <a 
                            href={https+"shop"} 
                            style={{display:'none'}}
                        >
                            Aplicar
                        </a>
                        <a id="closeVehicle">Cerrar</a>
                        </div>
                    </div>
                    {vehicles.map((v)=>
                        {
                            return (
                                <a 
                                    className="itemSubcategory flex"
                                    onClick={() =>changeVehicle(v.id)}
                                >
                                    <p>{v.name}</p>
                                    <img 
                                        name={v.name}
                                        id={"vehicle_mobile_" + v.id}
                                        className="vehicle_list_mobile dnone"
                                        src={https+"img/check.svg"} 
                                        alt="selected"
                                    />
                                </a>
                            )
                        }
                    )}

                    </div>

                    <div className="subCategory colflex" id="subSize">
                    <div className="actions flex">
                        <div className="flex subBack" id="backSize">
                        <img src="/img/back.svg" alt="⬅"/>
                        <p>Atrás</p>
                        </div>
                        <div className="flex">
                        <a 
                            href={https+"shop"} 
                            style={{display:'none'}}
                        >
                            Aplicar
                        </a>
                        <a id="closeSize">Cerrar</a>
                        </div>
                    </div>
                    <a className="itemSubcategory flex">
                        <p>13"</p>
                        <img src="/img/check.svg" alt="selected" className="dnone"/>
                    </a>

                    <a className="itemSubcategory flex">
                        <p>14"</p>
                        <img src="/img/check.svg" alt="selected" className="dnone"/>
                    </a>

                    <a className="itemSubcategory flex">
                        <p>15"</p>
                        <img src="/img/check.svg" alt="selected" className="dnone"/>
                    </a>

                    </div>
                    
                    <div className="subCategory colflex" id="subPrice">
                    <div className="actions flex">
                        <div className="flex subBack" id="backPrice">
                        <img src="/img/back.svg" alt="⬅"/>
                        <p>Atrás</p>
                        </div>
                        <div className="flex">
                        <a 
                            href={https+"shop"} 
                            style={{display:'none'}}
                        >
                            Aplicar
                        </a>
                        <a id="closePrice">Cerrar</a>
                        </div>
                    </div>
                        <a 
                            className="itemSubcategory flex"
                            onClick={() =>changePrice(1)}
                        >
                            <p>Hasta $200.000</p>
                            <img 
                                name="Hasta $200.000"
                                id={"price_mobile_" + 1}
                                className="price_list_mobile dnone"
                                src={https+"img/check.svg"} 
                                alt="selected"
                            />
                        </a>
                        <a 
                            className="itemSubcategory flex"
                            onClick={() =>changePrice(2)}
                        >
                            <p>$200.000 a $500.000</p>
                            <img 
                                name="$200.000 a $500.000"
                                id={"price_mobile_" + 2}
                                className="price_list_mobile dnone"
                                src={https+"img/check.svg"} 
                                alt="selected"
                            />
                        </a>
                        <a 
                            className="itemSubcategory flex"
                            onClick={() =>changePrice(3)}
                        >
                            <p>$500.000 a $1.000.000</p>
                            <img 
                                name="$500.000 a $1.000.000"
                                id={"price_mobile_" + 3}
                                className="price_list_mobile dnone"
                                src={https+"img/check.svg"} 
                                alt="selected"
                            />
                        </a>
                        <a 
                            className="itemSubcategory flex"
                            onClick={() =>changePrice(4)}
                        >
                            <p>$1.000.000 a $2.000.000</p>
                            <img 
                                name="$1.000.000 a $2.000.000"
                                id={"price_mobile_" + 4}
                                className="price_list_mobile dnone"
                                src={https+"img/check.svg"} 
                                alt="selected"
                            />
                        </a>
                        <a 
                            className="itemSubcategory flex"
                            onClick={() =>changePrice(5)}
                        >
                            <p>$2.000.000 a $3.000.000</p>
                            <img 
                                name="$2.000.000 a $3.000.000"
                                id={"price_mobile_" + 5}
                                className="price_list_mobile dnone"
                                src={https+"img/check.svg"} 
                                alt="selected"
                            />
                        </a>
                        <a 
                            className="itemSubcategory flex"
                            onClick={() =>changePrice(6)}
                        >
                            <p>$3.000.000 a $4.000.000</p>
                            <img 
                                name="$3.000.000 a $4.000.000"
                                id={"price_mobile_" + 6}
                                className="price_list_mobile dnone"
                                src={https+"img/check.svg"} 
                                alt="selected"
                            />
                        </a>
                        <a 
                            className="itemSubcategory flex"
                            onClick={() =>changePrice(7)}
                        >
                            <p>$4.000.000 a $5.000.000</p>
                            <img 
                                name="$4.000.000 a $5.000.000"
                                id={"price_mobile_" + 7}
                                className="price_list_mobile dnone"
                                src={https+"img/check.svg"} 
                                alt="selected"
                            />
                        </a>
                        <a 
                            className="itemSubcategory flex"
                            onClick={() =>changePrice(8)}
                        >
                            <p>desde $5.000.000</p>
                            <img 
                                name="desde $5.000.000"
                                id={"price_mobile_" + 8}
                                className="price_list_mobile dnone"
                                src={https+"img/check.svg"} 
                                alt="selected"
                            />
                        </a>

                    </div>
        
                    <select
                        name="option"
                        id="option_desktop"
                        onChange={onChangeOption}
                        value={option}
                    >
                        <option value="0">Ordenar por:</option>
                        <option value="1">A-Z</option>
                        <option value="2">Z-A</option>
                        <option value="3">Mas vendido</option>
                        <option value="4">Descuentos</option>
                        <option value="5">Mayor precio</option>
                        <option value="6">Menor precio</option>
                    </select>
                </div>
        
                <div className="orderCategories dnone">
                <p id="p_results">
                    <span style={{display:'block'}}>Productos</span>
                    <span className='categories' style={{display:'none'}}>
                    </span> 
                    <span className='brands' style={{display:'none'}}>
                    </span> 
                    <span className='lines' style={{display:'none'}}>
                    </span> 
                    <span className='years' style={{display:'none'}}>
                    </span> 
                    <span className='vehicles' style={{display:'none'}}>
                    </span> 
                    <span className='price' style={{display:'none'}}>
                    </span> 
                </p>
                <select
                    name="option"
                    onChange={onChangeOption}
                    value={option}
                >
                    <option>Ordenar por:</option>
                    <option value="1">A-Z</option>
                    <option value="2">Z-A</option>
                    <option value="3">Mas vendido</option>
                    <option value="4">Descuentos</option>
                    <option value="5">Mayor precio</option>
                    <option value="6">Menor precio</option>
                </select>
                </div>
        
                <aside className="categoryList dnone">
                <h3>Filtrar por:</h3>

                <div className="container colflex">
                    <div className="resetFilter">
                        <p class="clearFilter" onClick={clearFilter}>
                            Reiniciar Filtros
                        </p>
                    </div>
                    <div className="resetFilter">
                        <p onClick={categoriesOpen}>
                            Categorías
                            <img className='img_arrow' src={https+"img/arrow2.svg"} alt="➡"/>
                        </p>
                    </div>
                    {categories.map((c)=>
                        {
                            if(products.length > 0 && categories.length > 0 && validate_category_select == 1){
                                validate_category_select = 2;
                                setTimeout(function(){
                                    $('#category_'+category_select).click();
                                    changeCategory(category_select)
                                },1000);
                            }
                            return (
                                <div 
                                    className="flex category_list_check list_check" 
                                    key={c.id}
                                >
                                    <label for="">{c.name}</label>
                                    <input
                                        name="category_id"
                                        value={c.id}
                                        type="checkbox"
                                        id={"category_" + c.id} 
                                        className="category_list"
                                        onClick={() => changeCategory(c.id)}
                                    />
                                </div>
                            )
                        }
                    )}
                </div>

                <div className="container colflex">
                    <div className="resetFilter">
                        <p onClick={brandOpen}>Marcas
                            <img className='img_arrow' src={https+"img/arrow2.svg"} alt="➡"/>
                        </p>
                    </div>
                    {brands.map((b)=>
                        {
                            if(brands.length > 0 && validate_brand_select == 1){
                                validate_brand_select = 2;
                                setTimeout(function(){
                                    $('#brand_'+brand_select).click();
                                    changeBrand(brand_select);
                                    //setTimeout(function(){
                                        //$('input[name=option]').val("1");
                                    //},1000);
                                },1000);
                            }
                            return (
                                <div 
                                    className="flex brand_list_check list_check"
                                    key={b.id}
                                >
                                    <label for="">{b.name}</label>
                                    <input
                                        name="brand_id"
                                        id={"brand_" + b.id}
                                        name_go={b.name}
                                        value={b.id}
                                        type="checkbox"
                                        className="brand_list"
                                        onClick={() => changeBrand(b.id)}
                                    />
                                </div>
                            )
                        }
                    )}
                </div>

                <div className="container colflex">
                    <div className="resetFilter">
                        <p onClick={lineOpen}>
                            Lineas
                            <img className='img_arrow' src={https+"img/arrow2.svg"} alt="➡"/>
                        </p>
                    </div>
                    {lines.map((l)=>
                        {
                            return (
                                <div 
                                    className="flex line_list_check list_check"
                                    key={l.id}
                                >
                                    <label for="">{l.name}</label>
                                    <input
                                        name="line_id"
                                        id={"line_" + l.id}
                                        name_go={l.name}
                                        value={l.id}
                                        type="checkbox"
                                        className="line_list"
                                        onClick={() => changeLine(l.id)}
                                    />
                                </div>
                            )
                        }
                    )}
                </div>

                <div className="container colflex">
                    <div className="resetFilter">
                        <p onClick={yearsOpen}>
                            Año
                            <img className='img_arrow' src={https+"img/arrow2.svg"} alt="➡"/>
                        </p>
                    </div>
                    {years.map((y)=>
                        {
                            return (
                                <div 
                                    className="flex year_list_check list_check" 
                                    key={y.id}
                                >
                                    <label for="">{y.name}</label>
                                    <input 
                                        name="year_id"
                                        value={y.id}
                                        type="checkbox"
                                        id={"year_" + y.id} 
                                        className="year_list"
                                        onClick={() => changeYear(y.id)}
                                    />
                                </div>
                            )
                        }
                    )}
                </div>

                <div className="container colflex">
                    <div className="resetFilter">
                        <p onClick={vehiclesOpen}>
                            Vehículo
                            <img className='img_arrow' src={https+"img/arrow2.svg"} alt="➡"/>
                        </p>
                    </div>
                    {vehicles.map((v)=>
                        {
                            return (
                                <div 
                                    className="flex vehicle_list_check list_check"
                                    key={v.id}>
                                    <label for="">{v.name}</label>
                                    <input
                                        name="vehicle_id"
                                        value={v.id}
                                        type="checkbox"
                                        id={"vehicle_" + v.id} 
                                        className="vehicle_list"
                                        onClick={() => changeVehicle(v.id)}
                                    />
                                </div>
                            )
                        }
                    )}
                </div>

                <div className="container colflex">
                    <div className="resetFilter">
                        <p onClick={priceOpen}>
                            Precio
                            <img className='img_arrow' src={https+"img/arrow2.svg"} alt="➡"/>
                        </p>
                    </div>
                    <div className="flex price_list_check list_check">
                        <label for="">Hasta $200.000</label>
                        <input 
                            name="price_id"
                            value={1}
                            type="checkbox"
                            id={"price_" + 1} 
                            className="price_list"
                            onClick={() => changePrice(1)}
                        />
                    </div>
                    <div className="flex price_list_check list_check">
                        <label for="">$200.000 a $500.000</label>
                        <input 
                            name="price_id"
                            value={2}
                            type="checkbox"
                            id={"price_" + 2} 
                            className="price_list"
                            onClick={() => changePrice(2)}
                        />
                    </div>
                    <div className="flex price_list_check list_check">
                        <label for="">$500.000 a $1.000.000</label>
                        <input 
                            name="price_id"
                            value={3}
                            type="checkbox"
                            id={"price_" + 3} 
                            className="price_list"
                            onClick={() => changePrice(3)}
                        />
                    </div>
                    <div className="flex price_list_check list_check">
                        <label for="">$1.000.000 a $2.000.000</label>
                        <input 
                            name="price_id"
                            value={4}
                            type="checkbox"
                            id={"price_" + 4} 
                            className="price_list"
                            onClick={() => changePrice(4)}
                        />
                    </div>
                    <div className="flex price_list_check list_check">
                        <label for="">$2.000.000 a $3.000.000</label>
                        <input 
                            name="price_id"
                            value={5}
                            type="checkbox"
                            id={"price_" + 5} 
                            className="price_list"
                            onClick={() => changePrice(5)}
                        />
                    </div>
                    <div className="flex price_list_check list_check">
                        <label for="">$3.000.000 a $4.000.000</label>
                        <input 
                            name="price_id"
                            value={6}
                            type="checkbox"
                            id={"price_" + 6} 
                            className="price_list"
                            onClick={() => changePrice(6)}
                        />
                    </div>
                    <div className="flex price_list_check list_check">
                        <label for="">$4.000.000 a $5.000.000</label>
                        <input 
                            name="price_id"
                            value={7}
                            type="checkbox"
                            id={"price_" + 7} 
                            className="price_list"
                            onClick={() => changePrice(7)}
                        />
                    </div>
                    <div className="flex price_list_check list_check">
                        <label for="">desde $5.000.000</label>
                        <input 
                            name="price_id"
                            value={8}
                            type="checkbox"
                            id={"price_" + 8} 
                            className="price_list"
                            onClick={() => changePrice(8)}
                        />
                    </div>
                </div>

                </aside>
        
                <div className="listProducts">
                    <div class="grid">
                        {vector.map((v) => {
                            if (products.length > 1) {
                                setTimeout(function (){
                                    $('.pages').hide();
                                    $('.page_1').show();
                                },100);
                            }
                        })}
                        {vector.map((v) => {
                            if(products.length <= 0){
                                return <div key={v} className="not_products column total colflex" style={{
                                    textAlign:`center`,
                                    margin:`0%`,
                                    width: `100%`,
                                    display: `none`
                                }}>
                                    <h4>
                                        No hay productos
                                    </h4>
                                </div>
                            }
                        })}
                        {vector.map((v) => {
                            if(products.length <= 0){
                                return <div key={v} className="loading column total colflex" style={{
                                    textAlign:`center`,
                                    margin:`0%`,
                                    width: `100%`
                                }}>
                                    <h4>
                                        Cargando . . .
                                    </h4>
                                </div>
                            }
                        })}
                        {products.map((p)=> {
                            if (cont >= 15) {
                                pageNext = 2;
                                page++
                                cont = 0;
                            }
                            cont++
                            
                            countLine = 1;

                            if(p.descount > 0){
                                total = new Intl.NumberFormat().format(p.price);
                                total = total.replace(/,/g , ".");
                                price = (p.price - (p.price * p.descount / 100));
                                total_d = new Intl.NumberFormat().format(price);
                                total_d = total_d.replace(/,/g , ".");
                                return(
                                    <a href={https+'product/'+p.id} 
                                    className={'product colflex pages page_'+ page} key={p.id}
                                    >
                                        <div className="img">
                                            <div>
                                                <img src={https+p.img} alt="item"/>
                                            </div>
                                        </div>
                                        <p>{p.name}</p>
                                        {brandsT.map((b)=>
                                        {
                                            if(b.id == p.brand_id){
                                                countBrand = 2;
                                                return <p className='p_2'>{b.name}</p>
                                            }
                                        }
                                        )}
                                        {vector.map((v) => {
                                            if(countBrand == 1){
                                                return <p className='p_2'>&nbsp;</p>
                                            }
                                        }
                                        )}
                                        {categoriesT.map((c)=>
                                        {
                                            if(c.id == p.category_id){
                                                countCategory = 2;
                                                return <p className='p_2'>{c.name}</p>
                                            }
                                        }
                                        )}
                                        {vector.map((v) => {
                                            if(countCategory == 1){
                                                return <p className='p_2'>&nbsp;</p>
                                            }
                                        }
                                        )}
                                        {linesT.map((l)=>
                                            {
                                                if(l.id == p.line_id){
                                                    countLine = 2;
                                                    return <p className='p_2'>{l.name}</p>
                                                }
                                            }
                                        )}
                                        {vector.map((v) => {
                                            if(countLine == 1){
                                                return <p className='p_2'>&nbsp;</p>
                                            }
                                        }
                                        )}
                                        <span className="price">${total}</span>
                                        <div className="flex">
                                            <h4 className="offer">${total_d}</h4>
                                            <h5 className="discount">
                                                {p.descount}% OFF
                                            </h5>
                                        </div>
                                    </a>
                                )
                            }else{
                                total = new Intl.NumberFormat().format(p.price);
                                total = total.replace(/,/g , ".");
                                return (
                                    <a href={https+'product/'+p.id} 
                                    className={'product colflex pages page_'+ page} key={p.id}
                                    >
                                        <div className="img">
                                            <div>
                                                <img src={https+p.img} alt="item"/>
                                            </div>
                                        </div>
                                        <p>{p.name}</p>
                                        {brandsT.map((b)=>
                                        {
                                            if(b.id == p.brand_id){
                                                countBrand = 2;
                                                return <p className='p_2'>{b.name}</p>
                                            }
                                        }
                                        )}
                                        {vector.map((v) => {
                                            if(countBrand == 1){
                                                return <p className='p_2'>&nbsp;</p>
                                            }
                                        }
                                        )}
                                        {categoriesT.map((c)=>
                                        {
                                            if(c.id == p.category_id){
                                                countCategory = 2;
                                                return <p className='p_2'>{c.name}</p>
                                            }
                                        }
                                        )}
                                        {vector.map((v) => {
                                            if(countCategory == 1){
                                                return <p className='p_2'>&nbsp;</p>
                                            }
                                        }
                                        )}
                                        {linesT.map((l)=>
                                            {
                                                if(l.id == p.line_id){
                                                    countLine = 2;
                                                    return <p className='p_2'>{l.name}</p>
                                                }
                                            }
                                        )}
                                        {vector.map((v) => {
                                            if(countLine == 1){
                                                return <p className='p_2'>&nbsp;</p>
                                            }
                                        }
                                        )}
                                        <span className="price">&nbsp;</span>
                                        <div className="flex">
                                            <h4 className="offer">${total}</h4>
                                            <h5 className="discount"></h5>
                                        </div>
                                    </a>
                                )
                            }
                        })}
                    </div>

                    <div className="pagination grid">
                        {vector.map((v) => {
                            if (pageNext > 0) {
                                return <div className="flex"
                                            id={0} key={v}
                                        >
                                            <a className="pagePrev" id="0" onClick={prev}>
                                                <span>Pagina Anterior</span>
                                            </a>
                                        </div>
                            }
                        })}
                        {vector.map((v) => {
                            if (pageNext > 0) {
                                return <div className="flex"
                                            key={v}
                                        >
                                            <a className="pageNext" id={pageNext} onClick={next}>
                                                <span>Pagina Siguiente</span>
                                            </a>
                                        </div>
                            }
                        })}
                    </div> 

                </div>
        
            </div>
            </section>
        </main>
)
}

export default List
